import { Target, Calendar, Users, Clock, Shield, Palette, DollarSign, Heart } from "lucide-react"
export const advantages = [
  {
    id: 1,
    icon: Target,
    title: "Реалізуємо складні нетипові проєкти",
    description: "Беремося за найскладніші та нестандартні завдання, які інші не наважуються виконувати",
  },
  {
    id: 2,
    icon: Calendar,
    title: "Чітко і поетапно плануємо роботи",
    description: "Детальне планування кожного етапу з прозорим графіком виконання робіт",
  },
  {
    id: 3,
    icon: Users,
    title: "Створюємо індивідуальний та комплексний підхід без хаосу",
    description: "Персональний підхід до кожного клієнта з урахуванням всіх побажань та особливостей",
  },
  {
    id: 4,
    icon: Clock,
    title: "Дотримуємось чітких термінів",
    description: "Завершуємо роботи точно в обумовлені терміни без затримок та переносів",
  },
  {
    id: 5,
    icon: Shield,
    title: "Контролюємо та гарантуємо якість",
    description: "Багаторівневий контроль якості на кожному етапі з гарантією до 5 років",
  },
  {
    id: 6,
    icon: Palette,
    title: "Поєднуємо функціональність та естетику",
    description: "Створюємо простори, які є не тільки красивими, але й максимально функціональними",
  },
  {
    id: 7,
    icon: DollarSign,
    title: "Економимо ваш час та бюджет",
    description: "Оптимізуємо витрати без втрати якості, працюємо ефективно та економно",
  },
  {
    id: 8,
    icon: Heart,
    title: "Втілюємо в життя ваші мрії про затишок і комфорт",
    description: "Створюємо простір, в якому ви будете почуватися щасливими та комфортно",
  },
]